// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__i7Wxk","MenuItem":"Menu_MenuItem__N3Wih"};